module.exports = __webpack_public_path__ + "static/ie-eaa586dbd0dc44fd641078245a836e09.mp4";